import React from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const EditItemMasterModal = ({ isOpen, onClose, editFormData, setEditFormData, fetchData }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    // === VALIDATION ===
  // === VALIDATION ===
if (!editFormData.serialNo || editFormData.serialNo.trim() === "") {
  Swal.fire({
    icon: "warning",
    title: "Validation Error",
    text: "Serial Number should not be empty.",
  });
  return;
}

if (isNaN(editFormData.serialNo)) {
  Swal.fire({
    icon: "warning",
    title: "Validation Error",
    text: "Serial Number must be a number only.",
  });
  return;
}


    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.put(
        `https://rfs2.infraconsoft.net.in/api/itemMaster_editSerial/${editFormData.id}`,
        {
          serialNo: editFormData.serialNo,
        }
      );

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Serial Number updated successfully.",
        });
        onClose();
        navigate("/inventory/itemmasterviewnew");
      }
    } catch (error) {
      console.error("Error updating Serial Number:", error);

      // 🔍 Handle duplicate serial error from backend
      if (error.response && error.response.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Duplicate Serial No",
          text: error.response.data.message || "This Serial No already exists.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Update failed. Please try again.",
        });
      }
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <button
          className="close-btn"
          onClick={onClose}
          style={{ position: "initial" }}
        >
          &times;
        </button>
        <h3>Edit Serial Number</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Item Code :</label>
              <input
                type="text"
                name="itemCode"
                value={editFormData.itemCode}
                onChange={handleEditChange}
                readOnly
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Serial No :</label>
              <input
                type="text"
                name="serialNo"
                value={editFormData.serialNo}
                onChange={handleEditChange}
              />
            </div>
          </div>

          <div className="btn-cls">
            <button type="submit" className="submit-btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditItemMasterModal;
